import { render, staticRenderFns } from "./mobileform.vue?vue&type=template&id=1507bf5e&scoped=true&"
import script from "./mobileform.vue?vue&type=script&lang=js&"
export * from "./mobileform.vue?vue&type=script&lang=js&"
import style0 from "./mobileform.vue?vue&type=style&index=0&id=1507bf5e&prod&scoped=true&lang=scss&"
import style1 from "./mobileform.vue?vue&type=style&index=1&id=1507bf5e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1507bf5e",
  null
  
)

export default component.exports